document.addEventListener("DOMContentLoaded", function () {
  const prevButton = document.querySelector(".swiper-button-prev");
  const nextButton = document.querySelector(".swiper-button-next");
  const relatedArticlesSwiper = new Swiper(".related-articles__swiper", {
    spaceBetween: 12,
    slidesPerView: 1.2,
    breakpoints: {
      500: {
        slidesPerView: 2,
      },
      990: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
  });
});
